import React, { useState } from 'react';
import { BookOpenIcon, PrinterIcon } from 'lucide-react';
import { SectionHeading } from '../SectionHeading';
import { ManualViewer } from '../ManualViewer';
import { ZoomablePage } from '../ZoomablePage';
import { Carousel } from '../Carousel';
import { Lightbox } from '../Lightbox/Lightbox';
import { MANUAL_PAGES, PATTERN_PAGES, SAMPLE_MODEL } from '../../data/collection';
function PartLabel({
  icon,
  children
}: {
  icon: React.ReactNode;
  children: React.ReactNode;
}) {
  return <p className="inline-flex items-center gap-2 rounded-full bg-paper px-4 py-2 text-[0.95rem] font-extrabold text-graphite ring-1 ring-inset ring-graphite/10" data-id="element-249" data-mp="2y27iazb8osez">
      {icon}
      {children}
    </p>;
}
export function ModelPreviewSection() {
  const [manualIndex, setManualIndex] = useState<number | null>(null);
  const [patternIndex, setPatternIndex] = useState<number | null>(null);
  return <section id="modelo" aria-labelledby="modelo-title" className="w-full bg-ivory-deep" data-id="element-250" data-mp="2fbprj09yw6w9">
      <div className="mx-auto max-w-6xl px-5 py-16 sm:px-8 lg:py-24" data-id="element-251" data-mp="1ynhr89ndf8b2">
        <SectionHeading id="modelo-title" title="No solo recibís los moldes. También te mostramos cómo confeccionar cada prenda, paso a paso." intro={`Cada modelo tiene instrucciones de preparación, corte, armado y terminaciones, y sus moldes vienen listos para imprimir en A4 a tamaño real. Recorré como ejemplo el manual y el molde del ${SAMPLE_MODEL.name}.`} data-id="element-252" data-mp="1ypuacq4v7opp" />

        <div className="mt-12" data-id="element-253" data-mp="1fuvor6hykjhi">
          <PartLabel icon={<BookOpenIcon className="h-4 w-4 text-coral-ink" aria-hidden data-id="element-255" data-mp="1ax3wuchbcxdb" />} data-id="element-254" data-mp="1axnfjvesfpse">Manual de confección</PartLabel>
          <div className="mt-6" data-id="element-256" data-mp="16xczfpxa7izt">
            <ManualViewer pages={MANUAL_PAGES} modelName={SAMPLE_MODEL.name} volume={SAMPLE_MODEL.volume} onOpen={setManualIndex} data-id="element-257" data-mp="16yo4ru6dkyt1" />
          </div>
        </div>

        <div className="mt-16 border-t border-dashed border-coral/40 pt-12 lg:mt-20" data-id="element-258" data-mp="2wbrlu3ktuts5">
          <div className="grid grid-cols-1 gap-6 lg:grid-cols-[minmax(0,0.8fr)_minmax(0,1.2fr)] lg:gap-14 [&>*]:min-w-0" data-id="element-259" data-mp="3fg4u99nthtwa">
            <div data-id="element-260" data-mp="3k7czdti46t3n">
              <PartLabel icon={<PrinterIcon className="h-4 w-4 text-sage-ink" aria-hidden data-id="element-262" data-mp="3k8ece3ioxpo0" />} data-id="element-261" data-mp="3k7v4lfmr8hnp">Moldes para imprimir</PartLabel>
              <h3 className="mt-5 font-serif text-[1.5rem] font-semibold leading-tight text-graphite sm:text-[1.75rem]" data-id="element-263" data-mp="36h9kjnlke1o8">
                Así se ve el molde del mismo vestido.
              </h3>
              <p className="mt-3 text-[1.05rem] leading-relaxed text-graphite-soft" data-id="element-264" data-mp="2zhnvvwhgtjp">
                Tres páginas del PDF de moldes del Volumen 2: el esquema de armado y dos hojas con los diez talles, a
                escala real y con margen de 7 mm incluido.
              </p>
              <p className="mt-3 text-[0.95rem] leading-relaxed text-graphite-soft" data-id="element-265" data-mp="3u3pv0wx7zh11">
                Son muestras para que veas el contenido. Para coser, imprimís desde el PDF original que recibís con la
                colección.
              </p>
            </div>
            <Carousel items={PATTERN_PAGES} label="Hojas del molde" grid="md-3" itemClassName="w-[62%] sm:w-[40%]" getKey={page => page.file} renderItem={(page, index) => <figure className="w-full" data-id="element-267" data-mp="2k4x5ak8txdoa">
                  <ZoomablePage image={page} label={page.caption} onOpen={() => setPatternIndex(index)} data-id="element-268" data-mp="2f7ewquyq50gt" />
                  <figcaption className="mt-2.5 text-[0.92rem] font-semibold text-graphite" data-id="element-269" data-mp="1rhkjwdeenbwk">{page.caption}</figcaption>
                </figure>} data-id="element-266" data-mp="2b6340gkjzz4e" />
          </div>
        </div>
      </div>

      <Lightbox items={MANUAL_PAGES} index={manualIndex} onClose={() => setManualIndex(null)} onNavigate={setManualIndex} label={`Manual de confección · ${SAMPLE_MODEL.name}`} data-id="element-270" data-mp="2196zsn1otz5n" />
      <Lightbox items={PATTERN_PAGES} index={patternIndex} onClose={() => setPatternIndex(null)} onNavigate={setPatternIndex} label={`Moldes para imprimir · ${SAMPLE_MODEL.name}`} counterNoun="Hoja" data-id="element-271" data-mp="18q1gw6kdrxuj" />
    </section>;
}